
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.81 17.955L12.25 2.725a1.4 1.4 0 00-.525-.53A1.414 1.414 0 0011 2c-.26 0-.502.065-.725.195a1.4 1.4 0 00-.524.53L1.19 17.955c-.26.455-.253.91.022 1.364.126.209.3.374.518.497.22.123.456.184.708.184h17.123c.253 0 .49-.061.709-.184a1.38 1.38 0 00.518-.497c.275-.455.283-.91.022-1.364zm-8.383-1.081a.34.34 0 01-.106.254.348.348 0 01-.25.102H9.93a.347.347 0 01-.25-.102.34.34 0 01-.107-.254v-2.056c0-.1.036-.185.106-.254a.347.347 0 01.251-.102h2.14c.097 0 .18.034.251.102a.34.34 0 01.106.254v2.056zm-.022-4.046a.241.241 0 01-.117.179.464.464 0 01-.262.07H9.963a.492.492 0 01-.267-.07c-.075-.048-.112-.107-.112-.18l-.19-4.942c0-.101.038-.177.112-.227.097-.08.186-.12.268-.12h2.452c.082 0 .171.04.268.12.074.05.111.119.111.205l-.2 4.965z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_warning_sign_white.svg